/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f7c73aa536d3d62273564b924b1fb290e6fd3f00";
